import React from 'react';

import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
import NextLink from 'next/link';

import buildRouteUrl from '../../helpers/buildRouteUrl';
import { Credit } from '../../types/types';

interface PropTypes {
  data: Credit;
}

function Person({ data }: PropTypes) {
  const t = useTranslations();

  const href = buildRouteUrl(`/person/${data._id}`);

  return (
    <div className="flex flex-col justify-center items-center mr-2">
      <NextLink href={href} about="">
        <NextImage
          className="rounded-md bg-gray-400 hover:opacity-[0.4] transition-all duration-200 w-[100px] md:w-[140px] min-w-[100px] md:min-w-[140px] h-[150px] md:h-[210px] min-h-[150px] md:min-h-[210px]"
          src={`https://cdn-proxy.trakio.app/t/p/w220_and_h330_face${data.avatar}`}
          alt={t('images_alts.person_image', { name: data.name })}
          width={140}
          height={210}
          sizes="
          (min-width: 300px) 100px,150px
          (min-width: 768px) 140px,210px"
          unoptimized
        />
      </NextLink>
      <NextLink href={href}>
        <span className="text-center text-white font-bold mt-2 w-full line-clamp-1">
          {data.name}
        </span>
      </NextLink>
      {data.character && (
        <span className="text-center text-white w-[100px] md:w-[140px] line-clamp-2">
          {data.character}
        </span>
      )}
    </div>
  );
}

export default Person;
